<template>
<div class="chapter">
<div class="inner_page">
<div id="sec-7">
<h1 class="h1a" id="pz7-6" style="margin-bottom: 2.2em; margin-top: 3.7em;">
					Contents </h1>
<p class="indent" id="pz7-7" style="margin-top: 0.3em; text-indent: 0">
<a href="#/frontmatter02#pz9-1" id="d1"><b>Acknowledgments</b></a></p>
<p class="indent" id="Ay3s" style="margin-top: 0.3em; text-indent: 0">
<a href="#/frontmatter03#pz13-1" id="d2"><b>Foreword</b></a></p>
<p class="indent" id="A6y">
<i>Jason Brian Santos</i></p>
<p class="indent" id="Anx" style="margin-top: 0.3em; text-indent: 0">
<a href="#/frontmatter04#pAn8" id="d3"><b>Introduction:</b> Addressing the Two Intergenerational Questions</a></p>
<p class="indent" id="Ag4">
<i>Holly Catterton Allen and Chris Barnett</i></p>
<p class="indent" id="AL4" style="margin-top: 0.3em; text-indent: 0">
<a href="#/frontmatter05#pAL1p" id="d4"><b>Prologue:</b> Four Stories</a></p>
<p class="indent" id="Aq1">
<i>Melissa Cooper, Amy Kippen, Aqueelah Ligonde, and Jim Merhaut</i></p>
<p class="center" id="pz7-8" style="margin-top: 1.5em; margin-bottom: .5em;">
<span href="#/part01#pAtgUl" id="d5" title="Link target outside of Sample"><b>PART ONE<br/>
					Becoming More Intentionally Intergenerational</b></span></p>
<p class="indent" id="pz7-10" style="text-indent: 0">
<span href="#/chapter01#pAbHE" id="d6" title="Link target outside of Sample"><b>Chapter One:</b> Why Now?</span></p>
<p class="indent" id="Ans4">
<i>Jason Brian Santos</i></p>
<p class="indent" id="pz7-11" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter02#pAxtP" id="d7" title="Link target outside of Sample"><b>Chapter Two:</b> Intergenerational Communities and a Theology of Accommodation</span></p>
<p class="indent" id="A0GO">
<i>Gareth Crispin</i></p>
<p class="indent" id="pz7-12" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter03#pAPN_" id="d8" title="Link target outside of Sample"><b>Chapter Three:</b> Learning to Love Together</span></p>
<p class="indent" id="Anq">
<i>Darwin K. Glassford</i></p>
<p class="indent" id="pz7-13" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter04#pAGt_" id="d9" title="Link target outside of Sample"><b>Chapter Four:</b> Generational Theory and Faith Communities</span></p>
<p class="indent" id="AKT">
<i>Lynn Barger Elliott</i></p>
<p class="center" id="pz7-14" style="margin-top: 1.5em; margin-bottom: .5em;">
<span href="#/part02#pAsEn" id="d10" title="Link target outside of Sample"><b>PART TWO<br/>
					Leading Intergenerational Change</b></span></p>
<p class="indent" id="pz7-16" style="text-indent: 0">
<span href="#/chapter05#pAg34" id="d11" title="Link target outside of Sample"><b>Chapter Five:</b> From <i>Multi</i>generational to <i>Inter</i>generational</span></p>
<p class="indent" id="APZ">
<i>Cory Seibel</i></p>
<p class="indent" id="pz7-17" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter06#pABkg" id="d12" title="Link target outside of Sample"><b>Chapter Six:</b> Intergenerational Principles and Three Stories</span></p>
<p class="indent" id="ALR">
<i>John Roberto</i></p>
<p class="indent" id="pz7-18" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter07#pAs3o" id="d13" title="Link target outside of Sample"><b>Chapter Seven:</b> Unlocking the Power of Intergenerational Leadership</span></p>
<p class="indent" id="ALs">
<i>Jessica Stollings</i></p>
<p class="indent" id="pz7-19" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter08#pAcYx" id="d14" title="Link target outside of Sample"><b>Chapter Eight:</b> In It for the Long Haul</span></p>
<p class="indent" id="AqQ">
<i>Joseph P. Conway</i></p>
<p class="center" id="pAzx" style="margin-top: 1.5em; margin-bottom: .5em;">
<span href="#/part03#pAuMf" id="d15" title="Link target outside of Sample"><b>PART THREE<br/>
					Current Research</b></span></p>
<p class="indent" id="pAiS3" style="text-indent: 0">
<span href="#/chapter09#pAPn3" id="d16" title="Link target outside of Sample"><b>Chapter Nine:</b> Five Best Intergenerational Practices for Small Churches</span></p>
<p class="indent" id="pAGo">
<i>Tori Bennett Smit</i></p>
<p class="indent" id="pAPt" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter10#pA3_X" id="d17" title="Link target outside of Sample"><b>Chapter Ten:</b> Well-Being, Discipleship, and Intergenerational Connectedness</span></p>
<p class="indent" id="pAThF">
<i>Joe Azzopardi</i></p>
<p class="indent" id="pAEA" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter11#pAshN" id="d18" title="Link target outside of Sample"><b>Chapter Eleven:</b> All Ages Learning Together</span></p>
<p class="indent" id="pA5f">
<i>Wilson McCoy</i></p>
<p class="center" id="pz8-2" style="margin-top: 1.5em; margin-bottom: .5em;">
<span href="#/part04#pA4KI" id="d19" title="Link target outside of Sample"><b>PART FOUR<br/>
					Including Every Generation</b></span></p>
<p class="indent" id="pAxy" style="text-indent: 0">
<span href="#/chapter12#pAlah" id="d20" title="Link target outside of Sample"><b>Chapter Twelve:</b> Babies and Toddlers, Too?</span></p>
<p class="indent" id="AcL3">
<i>Dawn Rundman</i></p>
<p class="indent" id="pASaH" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter13" id="d21" title="Link target outside of Sample"><b>Chapter Thirteen:</b> Millennials and Screeners</span></p>
<p class="indent" id="pASI">
<i>Dave Sanders</i></p>
<p class="indent" id="pARv" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter14#pAV2p" id="d22" title="Link target outside of Sample"><b>Chapter Fourteen:</b> Welcoming Emerging Adults</span></p>
<p class="indent" id="pA5Rn">
<i>Holly Catterton Allen</i></p>
<p class="indent" id="pAbv" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter15#pAIqP" id="d23" title="Link target outside of Sample"><b>Chapter Fifteen:</b> Engaging the Elders among Us</span></p>
<p class="indent" id="pAuHu">
<i>Diane E. Shallue</i></p>
<p class="center" id="pAy3e" style="margin-top: 1.5em; margin-bottom: .5em;">
<span href="#/part05#pAeGQ" id="d24" title="Link target outside of Sample"><b>PART FIVE<br/>
					Unique Ministries and Approaches</b></span></p>
<p class="indent" id="pAG47" style="text-indent: 0">
<span href="#/chapter16#pAxCQ" id="d25" title="Link target outside of Sample"><b>Chapter Sixteen:</b> Exploring Intentionally Intergenerational Environments</span></p>
<p class="indent" id="pA80U">
<i>Tammy Tolman</i></p>
<p class="indent" id="pAvxP" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter17#pAKsf" id="d26" title="Link target outside of Sample"><b>Chapter Seventeen:</b> Faith Storytelling with All Ages</span></p>
<p class="indent" id="pAWD">
<i>Karen DeBoer</i></p>
<p class="indent" id="pAYEY" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter18#pA_W0" id="d27" title="Link target outside of Sample"><b>Chapter Eighteen:</b> Walking beside Each Other</span></p>
<p class="indent" id="pAu5">
<i>Linda Staats</i></p>
<p class="indent" id="pA_2" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter19#pAhQ7" id="d28" title="Link target outside of Sample"><b>Chapter Nineteen:</b> The Art of Christian Relationships</span></p>
<p class="indent" id="pAKM">
<i>Liz Perraud</i></p>
<p class="indent" id="pAs3" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter20#pAhcV" id="d29" title="Link target outside of Sample"><b>Chapter Twenty:</b> Connecting the Generations through Visual Faith</span></p>
<p class="indent" id="pAcT6">
<i>Nancy S. Going</i></p>
<p class="indent" id="pAr-" style="margin-top: 0.3em; text-indent: 0">
<span href="#/chapter21#pAqCi" id="d30" title="Link target outside of Sample"><b>Chapter Twenty-One:</b> All-Age Worship</span></p>
<p class="indent" id="pAK2">
<i>Olivia B. Updegrove</i></p>
<p class="indent" id="pA1TG" style="margin-top: 0.3em; text-indent: 0">
<span href="#/backmatter01" id="d31" title="Link target outside of Sample"><b>Conclusion:</b> The Intergenerationally Sticky Church</span></p>
<p class="indent" id="pAYh" style="margin-bottom: .9em;">
<i>Cory Seibel</i></p>
<p class="indent" id="pz8-4" style="text-indent: 0">
<span href="#/backmatter02#pz265-6" id="d32" title="Link target outside of Sample"><b>Selected Bibliography</b></span></p>
<p class="indent" id="pz8-5" style="margin-top: 0.3em; text-indent: 0">
<span href="#/backmatter03#pz267-6" id="d33" title="Link target outside of Sample"><b>About the Contributors</b></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// loi.vue?13a9a231